import type { AnchorHTMLAttributes, ReactNode } from 'react';
import { cx, type Aparencia } from '../../componentes/ui';
import css from '../../componentes/ui/Botao.module.css';

/**
 * Âncora na mesma página (`#precos`) com a cara de `BotaoLink`.
 *
 * O `Link` do router não rola até o `#` — por isso aqui é um `<a>` comum, que o
 * navegador resolve sozinho (inclusive sem JavaScript, no HTML pré-renderizado).
 */
export function BotaoAncora({
  aparencia = 'secundario',
  grande,
  pequeno,
  larguraTotal,
  iconeDireita,
  className,
  children,
  ...resto
}: AnchorHTMLAttributes<HTMLAnchorElement> & {
  aparencia?: Aparencia;
  grande?: boolean;
  pequeno?: boolean;
  larguraTotal?: boolean;
  iconeDireita?: ReactNode;
}) {
  return (
    <a
      {...resto}
      className={cx(
        css.botao,
        css[aparencia],
        grande && css.grande,
        pequeno && css.pequeno,
        larguraTotal && css.larguraTotal,
        className,
      )}
    >
      {children}
      {iconeDireita}
    </a>
  );
}
